"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var vue_1 = __importDefault(require("vue"));
var vue_property_decorator_1 = require("vue-property-decorator");
var CollectionPreview_vue_1 = __importDefault(require("../collection-preview/CollectionPreview.vue"));
var article_preview_1 = require("../article-preview/article-preview");
var collection_preview_1 = require("../collection-preview/collection-preview");
var collection_preview_2 = require("../collection-preview/collection-preview");
var ArticlePreview_vue_1 = __importDefault(require("../article-preview/ArticlePreview.vue"));
var SearchInput_vue_1 = __importDefault(require("../search-input/SearchInput.vue"));
var video_preview_1 = require("../video-preview/video-preview");
var VideoPreview_vue_1 = __importDefault(require("../video-preview/VideoPreview.vue"));
var App = /** @class */ (function (_super) {
    __extends(App, _super);
    function App() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.fetched = false;
        _this.articlePreviews = [];
        _this.collectionPreviews = [];
        _this.videoPreviews = [];
        _this.searchTerm = '';
        _this.sections = [
            {
                id: 'all',
                name: _this.$t('common.all')
            },
            {
                id: 'articles',
                name: _this.$t('article.medfyle_summaries')
            },
            {
                id: 'videos',
                name: _this.$t('common.videos')
            },
            {
                id: 'collections',
                name: _this.$t('common.collections')
            },
        ];
        _this.activeSectionId = 'all';
        return _this;
    }
    App.prototype.created = function () {
        this.fetch();
    };
    App.prototype.fetch = function () {
        var _this = this;
        this.fetched = false;
        return this.$http.get('local/api/v2/user/library')
            .then(function (res) {
            _this.articlePreviews = res.data.articles.map(function (preview) {
                return (0, article_preview_1.createArticlePreview)(preview);
            });
            _this.collectionPreviews = res.data.collections.map(function (preview) {
                return (0, collection_preview_1.createCollectionPreview)(preview);
            });
            _this.videoPreviews = res.data.videos.map(function (preview) {
                return (0, video_preview_1.createVideoPreview)(preview);
            });
            _this.fetched = true;
        });
    };
    Object.defineProperty(App.prototype, "visibleArticlePreviews", {
        get: function () {
            var _this = this;
            if (!this.searchTerm) {
                return this.articlePreviews;
            }
            return this.articlePreviews.filter(function (preview) {
                return preview.slug.toLowerCase().includes(_this.searchTerm)
                    || preview.title.toLowerCase().includes(_this.searchTerm)
                    || preview.shortTitle.toLowerCase().includes(_this.searchTerm)
                    || preview.congress.toLowerCase().includes(_this.searchTerm)
                    || preview.journal.toLowerCase().includes(_this.searchTerm)
                    || preview.bibliography.toLowerCase().includes(_this.searchTerm)
                    || preview.topic.toLowerCase().includes(_this.searchTerm)
                    || (preview.organization && preview.organization.name.toLowerCase().includes(_this.searchTerm));
            });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(App.prototype, "visibleCollectionPreviews", {
        get: function () {
            var _this = this;
            if (!this.searchTerm) {
                return this.collectionPreviews;
            }
            return this.collectionPreviews.filter(function (preview) {
                return preview.slug.toLowerCase().includes(_this.searchTerm)
                    || preview.title.toLowerCase().includes(_this.searchTerm)
                    || preview.editorName.toLowerCase().includes(_this.searchTerm)
                    || preview.topics.filter(function (topic) {
                        return topic.name.toLowerCase().includes(_this.searchTerm);
                    }).length > 0;
            });
        },
        enumerable: false,
        configurable: true
    });
    App.prototype.toggleFavoriteArticle = function (articlePreview) {
        var _this = this;
        if (articlePreview.processing) {
            return;
        }
        articlePreview.processing = true;
        (0, article_preview_1.toggleFavorite)(articlePreview, this.$http)
            .then(function (data) {
            articlePreview.processing = false;
            var updatedArticlePreview = articlePreview;
            if (data.favorited) {
                updatedArticlePreview.favorited = true;
                return updatedArticlePreview;
            }
            if (!data.favorited) {
                updatedArticlePreview.favorited = false;
                return updatedArticlePreview;
            }
        })
            .then(function (preview) {
            if (!preview) {
                return;
            }
            _this.updateArticlePreview(preview);
        });
    };
    App.prototype.updateArticlePreview = function (preview) {
        var index = this.articlePreviews.findIndex(function (p) {
            return p.slug === preview.slug;
        });
        if (index === -1) {
            return;
        }
        this.articlePreviews.splice(index, 1, preview);
    };
    App.prototype.toggleFavoriteCollection = function (preview) {
        var _this = this;
        if (preview.processing) {
            return;
        }
        preview.processing = true;
        (0, collection_preview_2.toggleFavorite)(preview, this.$http)
            .then(function (data) {
            preview.processing = false;
            var updatedPreview = preview;
            if (data.favorited) {
                updatedPreview.favorited = true;
                return updatedPreview;
            }
            if (!data.favorited) {
                updatedPreview.favorited = false;
                return updatedPreview;
            }
        })
            .then(function (preview) {
            if (!preview) {
                return;
            }
            _this.updateCollectionPreview(preview);
        });
    };
    App.prototype.updateCollectionPreview = function (preview) {
        var index = this.collectionPreviews.findIndex(function (p) {
            return p.slug === preview.slug;
        });
        if (index === -1) {
            return;
        }
        this.collectionPreviews.splice(index, 1, preview);
    };
    App.prototype.updateSearchTerm = function (newSearchTerm) {
        this.searchTerm = newSearchTerm;
    };
    App.prototype.showSection = function (id) {
        this.activeSectionId = id;
    };
    App.prototype.emptySearchTerm = function () {
        var _this = this;
        this.$refs.searchInput.emptySearchTerm();
        this.$nextTick(function () {
            _this.$refs.searchInput.$el.focus();
        });
    };
    Object.defineProperty(App.prototype, "visibleVideoPreviews", {
        get: function () {
            var _this = this;
            if (!this.searchTerm) {
                return this.videoPreviews;
            }
            return this.videoPreviews.filter(function (preview) {
                return preview.slug.toLowerCase().includes(_this.searchTerm)
                    || preview.title.toLowerCase().includes(_this.searchTerm)
                    || preview.label.toLowerCase().includes(_this.searchTerm)
                    || preview.topics.filter(function (topic) {
                        return topic.name.toLowerCase().includes(_this.searchTerm);
                    }).length > 0;
            });
        },
        enumerable: false,
        configurable: true
    });
    App.prototype.toggleFavoriteVideo = function (preview) {
        var _this = this;
        if (preview.processing) {
            return;
        }
        preview.processing = true;
        (0, video_preview_1.toggleFavorite)(preview, this.$http)
            .then(function (data) {
            preview.processing = false;
            var updatedPreview = preview;
            if (data.favorited) {
                updatedPreview.favorited = true;
                return updatedPreview;
            }
            if (!data.favorited) {
                updatedPreview.favorited = false;
                return updatedPreview;
            }
        })
            .then(function (preview) {
            if (!preview) {
                return;
            }
            _this.updateVideoPreview(preview);
        });
    };
    App.prototype.updateVideoPreview = function (preview) {
        var index = this.videoPreviews.findIndex(function (p) {
            return p.slug === preview.slug;
        });
        if (index === -1) {
            return;
        }
        this.videoPreviews.splice(index, 1, preview);
    };
    App = __decorate([
        (0, vue_property_decorator_1.Component)({
            components: {
                ArticlePreview: ArticlePreview_vue_1.default,
                CollectionPreview: CollectionPreview_vue_1.default,
                SearchInput: SearchInput_vue_1.default,
                VideoPreview: VideoPreview_vue_1.default,
            }
        })
    ], App);
    return App;
}(vue_1.default));
exports.default = App;
